import * as React from "react";
import { useContext, useEffect } from "react";
import { iActiveSlaCycle, iCommunication, iEnquiry } from "../../../interfaces/iEnquiry";
import { useState } from "react";
import "./enquiry.scss";
import UserIcon from "../../../assets/img/user.svg";
import { Bell } from "react-feather";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { deactivateEnquiryWizard } from "../../../interfaces/enquiryList";
import { ToGenericComm } from "../../../interfaces/iGenericComm";
import Statuses from "../../../interfaces/Statuses";
import { BsExclamationLg, BsFileEarmark, BsMagic, BsPaperclip } from "react-icons/bs";
import { startVDrag } from "../../../Logic/Resize/vertical";
import Communication from "../communication/communication";
import { ActivateWizardModule } from "../../../Logic/Enquiries/activateWizard";
import { GlobalModalContext } from "../../../contexts/GlobalModalContext";
import { EnquiryContextMenu } from "../../Menu";
import { useContextMenu } from "../../../hooks/useContextMenu";
import { CopyTag } from "../../CopyTag";
import { EnquiryGridSelectionContext } from "../../../contexts/enquiry-grid-selection.context";
import { GetEnquiryCommunicationCount, GetEnquiryCommunications } from "../../../Logic/EmsAPI/Enquiries";
import { updateCommunicationCache } from "../../../state/communicationsCache";
import { GetMailboxPermissions } from "../../../interfaces/Permissions";
import { RootState, useAppDispatch } from "../../../state/store";
import { useSelector } from "react-redux";

export const SwitchContext = React.createContext({ changeCommToView: (commId: number) => {} });
type EnquiryProp = {
    e: iEnquiry;
    interface?: string;
    commOnclick: Function;
    activeCommId: number;
    hasActivateWiz: boolean;
    communications: iCommunication[];
    expanded?: boolean;
};
function Enquiry(props: EnquiryProp) {
    const e = props.e;
    const dispatch = useAppDispatch();
    const showModal = useContext(GlobalModalContext);
    const { selectionProperties } = useContext(EnquiryGridSelectionContext);
    const communications = props.communications;
    const permissions = useSelector((state: RootState) => state.permissions);
    const [expandedEnquiry, setExpandedEnquiry] = useState<boolean>(true);
    const [completedLoadedComms, setCompletedLoadedComms] = useState<boolean>(false);
    const commBody = React.useRef<HTMLTableSectionElement>(null);
    const keydownHandler = (commId: number, event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event == null) return;
        if (event.key != "ArrowUp" && event.key != "ArrowDown") return;
        event.preventDefault();
        const activeCommIndex = communications.findIndex(x => x.id === commId);
        let nextCommId = 0;
        let nextCommIndex;

        if (event.key == "ArrowUp") {
            nextCommIndex = activeCommIndex > 0 ? activeCommIndex - 1 : activeCommIndex;
        } else {
            nextCommIndex = activeCommIndex < communications.length - 1 ? activeCommIndex + 1 : activeCommIndex;
        }
        nextCommId = communications[nextCommIndex].id;
        let commContainer: HTMLElement = document.getElementById("commListHistory" + e.id)!;
        commContainer.scrollTop = nextCommIndex * 15;
        if (commId != nextCommId) {
            props.commOnclick(nextCommId);
        }
    };
    let HistoryList1;
    if (communications.length > 0) {
        HistoryList1 = communications.map((item, index) => (
            <Communication
                id={item.id}
                type={item.type}
                dateStamp={item.dateStamp}
                email={item.email}
                comm={ToGenericComm(item)}
                isCompletedEnquiry={Statuses.IsCompleted(e.status)}
                key={"com_" + item.id}
                interface={props.interface}
                onClick={props.commOnclick}
                activeCommId={props.activeCommId}
                onKeyDown={keydownHandler}
                enquiryId={props.e.id}
                extractionState={item.extractionState}
            />
        ));
    }
    function setCorrectCommHistoryHeight() {
        const topP = commBody.current;
        if (topP) {
            topP.style.overflowX = "auto";
            let sub = 96;
            switch (props.communications.length) {
                case 1:
                    sub = 25;
                    break;
                case 2:
                    sub = 48;
                    break;
                case 3:
                    sub = 72;
                    break;
            }
            topP.style.height = sub + "px";
        }
    }

    React.useEffect(() => {
        setCorrectCommHistoryHeight();
    }, [communications]);

    const getExpiryColour = (enquiryStatus: number, activeCycle: iActiveSlaCycle) => {
        if (activeCycle != null && !Statuses.IsCompleted(enquiryStatus)) {
            const currentDate = new Date();
            let reminderDate = activeCycle.reminder ? new Date(activeCycle.reminder) : undefined;
            let alarmDate = activeCycle.alarm ? new Date(activeCycle.alarm) : undefined;
            let timeoutDate = activeCycle.timeout ? new Date(activeCycle.timeout) : undefined;

            if (timeoutDate && timeoutDate < currentDate) {
                return " expiry-purple";
            } else if (alarmDate && alarmDate < currentDate) {
                return " expiry-red";
            } else if (reminderDate && reminderDate < currentDate) {
                return " expiry-orange";
            } else {
                return " expiry-green";
            }
        }
        return "";
    };

    const { contextMenuState, setContextMenuState } = useContextMenu();

    const showContextMenu = (enquiryId: number) => (event: React.MouseEvent) => {
        // Disable the default context menu
        event.preventDefault();

        if (props.hasActivateWiz) {
            const container = (document.getElementById("enquiryHolder") as HTMLElement) || null;
            if (container) {
                const containerRect = container.getBoundingClientRect();
                setContextMenuState({
                    keys: [],
                    visible: true,
                    x: event.pageX - containerRect.x,
                    y: event.pageY - containerRect.y,
                });
            } else setContextMenuState({ keys: [], visible: true, x: event.pageX, y: event.pageY });
        }
    };

    let [expiryColour, setExpiryColour] = useState(getExpiryColour(props.e.status, props.e.activeSlaCycle));
    const dateReceived = dateTimeFormatN22(e.dateReceived);
    const activeSlaCycleTimeOut = e?.activeSlaCycle?.timeout ? dateTimeFormatN22(e?.activeSlaCycle?.timeout) : "";
    useEffect(() => {
        var timer = setInterval(() => {
            const currentColour = getExpiryColour(e.status, e.activeSlaCycle);
            if (currentColour != expiryColour) {
                setExpiryColour(currentColour);
            }
        }, 60000);
        return function cleanup() {
            clearInterval(timer);
        };
    });
    useEffect(() => {
        var CommunicationTimer = setTimeout(async () => {
            var comlength = await GetEnquiryCommunicationCount(props.e.id);
            if (comlength.data) {
                if (comlength.data.count > props.communications.length) {
                    var comms = await GetEnquiryCommunications(props.e.id);

                    if (comms.data) {
                        dispatch(
                            updateCommunicationCache({
                                enquiryId: props.e.id,
                                communications: comms.data,
                                cachedAt: props.e.commUpdatedAt,
                            }),
                        );
                    }
                    setCompletedLoadedComms(true);
                } else {
                    setCompletedLoadedComms(true);
                }
            }
        }, 1000);
        return function cleanup() {
            clearTimeout(CommunicationTimer);
        };
    }, [props.communications]);

    useEffect(() => {
        setExpiryColour(getExpiryColour(props.e.status, props.e.activeSlaCycle));
    }, [props.e.status, props.e.activeSlaCycle]);

    const barPercentage = (priority: number) => {
        return ((255 - priority) / 255.0) * 100.0;
    };

    const startVDragging = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        startVDrag(e, communications.length, props.e.id);
    };
    function HasPermissionToActivateWizard(): boolean {
        return GetMailboxPermissions(permissions, e.mailbox).ActionUnownedEnquiry === true && e.owners.length === 0
            ? GetMailboxPermissions(permissions, e.mailbox).ActionUnownedEnquiry
            : GetMailboxPermissions(permissions, e.mailbox).ActionOtherOwnedEnquiry === true && e.owners.length >= 0
              ? GetMailboxPermissions(permissions, e.mailbox).ActionOtherOwnedEnquiry
              : new ActivateWizardModule().wizardPermitted(e);
    }
    const changeScroll = (event: any) => {
        event.preventDefault();
        const scrollAmount = event.deltaY > 0 ? 10 : -10; // Scroll 30px per wheel movement
        event.currentTarget.scrollTop += scrollAmount;
    };
    return (
        <>
            {!expandedEnquiry && (
                <div
                    key={e?.id}
                    id="enquiryHolder"
                >
                    <div
                        className={
                            "enquiryAbb" +
                            (!Statuses.IsCompleted(e.status) && e.hasNew ? " has-new" : "") +
                            (Statuses.IsCompleted(e.status) ? " active" : "") +
                            expiryColour
                        }
                        id={"e_" + e.id}
                    >
                        <div></div>
                        <div>{e.enquiryReference}</div>
                        <div className="limit-text">{e.subject}</div>
                        <div>
                            {e.hasAlarm && (
                                <Bell
                                    style={{ width: "12px" }}
                                    className="icon"
                                    data-testid="enq-alarm-icon1"
                                />
                            )}
                        </div>
                        <div>
                            <>
                                {Statuses.IsCompleted(e.status) ? (
                                    <div className="icon-label expiry--icon-label">
                                        Completed: &nbsp;
                                        {e.dateCompleted
                                            ? new Intl.DateTimeFormat("en-GB", {
                                                  year: "numeric",
                                                  month: "2-digit",
                                                  day: "2-digit",
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                              })
                                                  .format(new Date(e.dateCompleted))
                                                  .replace(",", "")
                                            : ""}
                                    </div>
                                ) : (
                                    <div className="icon-label expiry--icon-label">Expiry: {activeSlaCycleTimeOut}</div>
                                )}
                            </>{" "}
                        </div>
                        <div
                            onClick={() => {
                                setExpandedEnquiry(!expandedEnquiry);
                            }}
                        >
                            {expandedEnquiry ? (
                                <BsChevronUp style={{ fontSize: "12px" }}></BsChevronUp>
                            ) : (
                                <BsChevronDown
                                    style={{ fontSize: "12px" }}
                                    title="Expand Enquiry History"
                                ></BsChevronDown>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {expandedEnquiry && (
                <div
                    key={e?.id}
                    id="enquiryHolder"
                >
                    <div
                        className={"enquiry" + expiryColour}
                        id={"e_" + e.id}
                        key={"ee_" + e.id}
                        data-testid="enquiry1"
                        onDoubleClick={() => {
                            const wizardModule = new ActivateWizardModule();
                            if (props.hasActivateWiz) {
                                wizardModule.ActivateWizard(
                                    e.id,
                                    () => showModal({ type: "EnquiryLocked" }),
                                    HasPermissionToActivateWizard(),
                                );
                            }
                        }}
                    >
                        <div
                            className={
                                "enquiry--card" +
                                (!Statuses.IsCompleted(e.status) && e.hasNew ? " has-new" : "") +
                                " active" +
                                expiryColour
                            }
                            id={e?.id?.toString()}
                            onContextMenu={showContextMenu(e.id)}
                            data-testid="enquiry-card1"
                        >
                            {props.hasActivateWiz && contextMenuState.visible && (
                                <div style={{ position: "absolute" }}>
                                    <EnquiryContextMenu
                                        x={contextMenuState.x}
                                        y={contextMenuState.y}
                                        enquiryIds={
                                            !selectionProperties.multiSelect
                                                ? [e.id]
                                                : selectionProperties.selectedEnquiries.map(x => parseInt(x))
                                        }
                                        onHide={() => setContextMenuState({ keys: [], visible: false, x: 0, y: 0 })}
                                    />
                                </div>
                            )}
                            <div
                                className="vertical-border"
                                title="SLA"
                            ></div>
                            <div
                                className="sla-priority-bar"
                                title="SLA Priority"
                            >
                                <div
                                    style={{ height: barPercentage(e.priority) + "%" }}
                                    className="sla-priority--value"
                                ></div>
                            </div>
                            <div className="enquiry--card--enquiry-ref">
                                <CopyTag
                                    value={e.enquiryReference}
                                    tooltip={`Enquiry reference: ${e.enquiryReference}`}
                                />
                            </div>
                            <div
                                className="icon-label enquiry-owner"
                                title={`Enquiry owner: ${e.owners
                                    .map(item => {
                                        return `"${item.lastname}, ${item.firstname}"`;
                                    })
                                    .join(", ")}`}
                            >
                                <img
                                    src={UserIcon}
                                    alt=""
                                    className="icon"
                                />
                                <div
                                    className="label limit-text"
                                    data-testid="enquiry-owner1"
                                >
                                    {e.owners
                                        .map(item => {
                                            return `${item.lastname}, ${item.firstname}`;
                                        })
                                        .join("; ")}
                                </div>
                            </div>
                            <div
                                className="enquiry--card--enquirer-name limit-text"
                                title={`Enquirer: ${e.enquirerName}`}
                                data-testid="enquirer-name1"
                            >
                                <CopyTag
                                    value={e.enquirerName}
                                    tooltip={`Enquiry Name: ${e.enquirerName}`}
                                />
                            </div>
                            <div
                                className="enquiry--card--enquiry-subject limit-text"
                                title={`Enquiry subject: ${e.subject}`}
                                data-testid="enq-subject1"
                            >
                                <CopyTag
                                    value={e.subject}
                                    tooltip={`Enquiry Name: ${e.subject}`}
                                />
                            </div>

                            <div className="enquiry--card--right">
                                <div className="enquiry--card--right-row enquiry--card--enquiry-status  ">
                                    <div className="icon-label wiz-row">
                                        <div
                                            className="limit-text enq-stat-label1"
                                            title={`Enquiry status: ${Statuses.Name(e.status)}`}
                                            data-testid="enquiry-status1"
                                        >
                                            {Statuses.Name(e.status)}
                                        </div>
                                        {props.hasActivateWiz && HasPermissionToActivateWizard() && (
                                            <div
                                                style={{ paddingLeft: "7px" }}
                                                title="Activate Wizard"
                                                onClick={() =>
                                                    new ActivateWizardModule().ActivateWizard(
                                                        e.id,
                                                        () => showModal({ type: "EnquiryLocked" }),
                                                        HasPermissionToActivateWizard(),
                                                    )
                                                }
                                            ></div>
                                        )}
                                    </div>
                                </div>
                                <div className="enquiry--card--right-row received-date">
                                    <div className="label2">Received: {dateReceived}</div>
                                </div>
                                <div className="enquiry--card--right-row">
                                    <>
                                        {Statuses.IsCompleted(e.status) ? (
                                            <div className="icon-label">
                                                {!e.hasAlarm ? (
                                                    ""
                                                ) : (
                                                    <Bell
                                                        className="icon"
                                                        data-testid="enq-alarm-icon1"
                                                    />
                                                )}
                                                <div
                                                    className="enquiry--card--date-completed limit-text"
                                                    data-testid="enq-completed-label1"
                                                >
                                                    Completed:
                                                    <div
                                                        className="completed-date limit-text"
                                                        data-testid="enq-completed-date1"
                                                    >
                                                        {e.dateCompleted
                                                            ? new Intl.DateTimeFormat("en-GB", {
                                                                  year: "numeric",
                                                                  month: "2-digit",
                                                                  day: "2-digit",
                                                                  hour: "2-digit",
                                                                  minute: "2-digit",
                                                              })
                                                                  .format(new Date(e.dateCompleted))
                                                                  .replace(",", "")
                                                            : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="icon-label expiry--icon-label">
                                                {!e.hasAlarm ? (
                                                    ""
                                                ) : (
                                                    <Bell
                                                        className="icon"
                                                        data-testid="enq-alarm-icon1"
                                                    />
                                                )}
                                                <div className="label expiry--label">Expiry:</div>
                                                <div
                                                    className="date expiry--date limit-text"
                                                    data-testid="enquiry-expiry1"
                                                >
                                                    {activeSlaCycleTimeOut}
                                                </div>
                                            </div>
                                        )}
                                    </>{" "}
                                </div>
                                Communication items: {communications.length}
                            </div>
                            <div className="enquiry--card--chevron">
                                {props.hasActivateWiz && HasPermissionToActivateWizard() && (
                                    <i
                                        className="activate-wizard"
                                        title="Activate Wizard"
                                        onClick={() => {
                                            completedLoadedComms &&
                                                new ActivateWizardModule().ActivateWizard(
                                                    e.id,
                                                    () => showModal({ type: "EnquiryLocked" }),
                                                    HasPermissionToActivateWizard(),
                                                );
                                        }}
                                    >
                                        <BsMagic
                                            style={{
                                                fontWeight: "bold",
                                                color: "#000",
                                                marginTop: "10px",
                                                height: "16px",
                                                fontSize: "13px",
                                            }}
                                        />
                                    </i>
                                )}
                                {expandedEnquiry ? (
                                    <BsChevronUp
                                        style={{ fontSize: "12px" }}
                                        onClick={() => {
                                            setExpandedEnquiry(!expandedEnquiry);
                                        }}
                                        title="Collapse Enquiry History"
                                    ></BsChevronUp>
                                ) : (
                                    <BsChevronDown
                                        style={{ fontSize: "12px" }}
                                        onClick={() => {
                                            setExpandedEnquiry(!expandedEnquiry);
                                        }}
                                    ></BsChevronDown>
                                )}
                            </div>
                        </div>

                        {communications.length > 0 && (
                            <table
                                className="comm-list"
                                cellPadding={0}
                                cellSpacing={0}
                            >
                                <thead
                                    className={
                                        communications.length > 4
                                            ? "tHeaddWithScroll comm-list--header"
                                            : "tHeadd comm-list--header"
                                    }
                                >
                                    <tr
                                        style={{ height: "100%", width: "100%" }}
                                        className="noScrollBar"
                                    >
                                        <th
                                            style={{ width: "15px", textAlign: "center", paddingLeft: "4px" }}
                                            title="Priority"
                                        >
                                            <i style={{ width: "100%" }}>
                                                <BsExclamationLg style={{ height: "20px" }} />
                                            </i>
                                        </th>
                                        <th
                                            style={{
                                                width: "11px",
                                                textAlign: "center",
                                                padding: "0px",
                                                margin: "0px",
                                            }}
                                        >
                                            <i style={{ height: "20px" }}>
                                                <BsFileEarmark style={{ height: "20px" }} />
                                            </i>
                                        </th>
                                        <th
                                            style={{
                                                width: "15px",
                                                textAlign: "center",
                                                height: "20px",
                                                paddingRight: "4px",
                                            }}
                                        >
                                            <i
                                                style={{ width: "100%" }}
                                                title="Attachments"
                                            >
                                                <BsPaperclip style={{ height: "20px" }} />
                                            </i>
                                        </th>

                                        <td
                                            className="limit-text"
                                            style={{ width: "12%" }}
                                        >
                                            Date
                                        </td>
                                        <td
                                            className="limit-text"
                                            style={{ width: "20%" }}
                                        >
                                            From
                                        </td>
                                        <td
                                            className="limit-text"
                                            style={{ width: "20%" }}
                                        >
                                            To
                                        </td>
                                        <td
                                            className="limit-text"
                                            style={{ width: "35%" }}
                                        >
                                            Subject
                                        </td>
                                        <td
                                            className="limit-text"
                                            style={{ width: "7%", paddingRight: "10px", marginRight: "5px" }}
                                        >
                                            Size
                                        </td>
                                    </tr>
                                </thead>
                                <tbody
                                    className="comm-list--list"
                                    data-testid="enquiry-communication-list1"
                                    id={"commListHistory" + props.e.id}
                                    onWheel={changeScroll}
                                    ref={commBody}
                                >
                                    {communications.length == 0 && (
                                        <tr>
                                            <td style={{ padding: "13px" }}>No enquiry history to display</td>
                                        </tr>
                                    )}
                                    {HistoryList1}
                                </tbody>
                                <tfoot>
                                    <tr style={{ height: "6px" }}>
                                        <td
                                            colSpan={8}
                                            className={communications.length > 4 ? "commResizeWait" : "commResize"}
                                            onMouseDown={event => startVDragging(event)}
                                        ></td>
                                    </tr>
                                </tfoot>
                            </table>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export const handleDeactivateWizard1 = (enquiryId: number, userId: number) => {
    let promise = new Promise<any>((resolve, reject) => {
        deactivateEnquiryWizard(enquiryId)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            });
    });
    return promise;
};

export const dateTimeFormat222 = (dateTime: string) => {
    try {
        return new Intl.DateTimeFormat("en-GB", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
            .format(new Date(dateTime))
            .replace(",", "");
    } catch (err) {
        return dateTime;
    }
};
export const dateTimeFormatN22 = (dateTime: string) => {
    try {
        return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
            .format(new Date(dateTime))
            .replace(",", "");
    } catch (err) {
        return dateTime;
    }
};
export function GridDateTimeDisplay(dateTime: string) {
    //"2025-01-24T10:07:50.63+02:00";
    if (dateTime.length < 19) {
        return "";
    }

    const result =
        dateTime.substring(8, 10) +
        "/" +
        dateTime.substring(5, 7) +
        "/" +
        dateTime.substring(2, 4) +
        " " +
        dateTime.substring(11, 16);

    return result;
}
export const dateTimeFormatLong = (dateTime: string) => {
    try {
        return new Intl.DateTimeFormat("en-GB", {
            dateStyle: "full",
            timeStyle: "short",
        })
            .format(new Date(dateTime))
            .replace(",", "");
    } catch (err) {
        return dateTime;
    }
};

export default Enquiry;
